import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ShortcutKeys() {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  useEffect(() => {
    const handler = (e) => {

      // 🚫 Ignore typing inside inputs
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      if (role === "delivery") {
        return;
      }
      // Ctrl + L → Stock List
      if (e.ctrlKey && e.key.toLowerCase() === "l") {
        e.preventDefault();
        navigate("/stock-list");
      }

      // Ctrl + S  → Stock Transfer
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        navigate("/stock-transfer");
      }

      // Ctrl + I → Invoices
      if (e.ctrlKey && e.key.toLowerCase() === "i") {
        e.preventDefault();
        navigate("/invoices");
      }

      // Ctrl + O → Orders
      if (e.ctrlKey && e.key.toLowerCase() === "o") {
        e.preventDefault();
        navigate("/orders");
      }

      // Ctrl + R → Returns
      if (e.ctrlKey && e.key.toLowerCase() === "r") {
        e.preventDefault();
        navigate("/sales-return");
      }

      // Ctrl + P → Payment Receipt
      if (e.ctrlKey && e.key.toLowerCase() === "p") {
        e.preventDefault();
        navigate("/payment-receipt");
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate]);

  return null;
}
